import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "../SignupPages/SignupCommon.css";

const IntakeFormPage11: React.FC = () => {
  const [idealWeight, setIdealWeight] = useState<string>("");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const completeIntakeStep7 = localStorage.getItem("complete-intake-step7");
    if (completeIntakeStep7) {
      navigate("/complete-intake/step-8", { replace: true });
    } else {
      navigate("/complete-intake/step-7", { replace: true });
    }
  }, []);

  const handleNext = () => {
    if (idealWeight) {
      localStorage.setItem(
        "idealWeight",
        JSON.stringify({ key: "idealWeight", value: idealWeight, id: 18026063 })
      );
    }
    navigate("/complete-intake/step-9");
    localStorage.setItem("complete-intake-step8", "true");
  };

  useEffect(() => {
    const savedIdealWeight = localStorage.getItem("idealWeight");

    if (savedIdealWeight) {
      const parsedIdealWeight = JSON.parse(savedIdealWeight);
      setIdealWeight(parsedIdealWeight.value);
    }
  }, []);

  const styles = {
    label: {
      marginBottom: "10px",
      fontWeight: "bold",
    },
    inputContainer: {
      marginBottom: "20px",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "20px",
    },
    disabledButton: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
    errorText: {
      color: "red",
      fontSize: "12px",
      marginTop: "5px",
    },
  };
  const handleIdealWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newWeight = e.target.value;
    setIdealWeight(newWeight);
    if (parseFloat(newWeight) <= 0) {
      setError("Ideal Weight should be greater than 0.");
      return;
    }
    setError("");
  };
  const isVariant = localStorage.getItem("isVariant") === "true";
  const step = 8;
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={isVariant ? 100 : 80} step={step} />
        <div className="signup-content">
          <p className="signup-question signup-question-mobile">
            What is your ideal weight?
          </p>
          <div style={styles.inputContainer}>
            <input
              id="weight-input"
              type="number"
              value={idealWeight}
              onChange={handleIdealWeightChange}
              placeholder="LBS"
              className="weight-input"
            />
            {error && <p style={styles.errorText}>{error}</p>}
          </div>
          <button
            onClick={handleNext}
            disabled={!idealWeight || !!error}
            className="next-btn sticky-btn"
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage11;
